import React from 'react';
import { motion } from 'framer-motion';
import { MyVision } from '../../data/data';

interface MyVisionSectionProps {
  data: MyVision;
}

const MyVisionSection: React.FC<MyVisionSectionProps> = ({ data }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section id="my-vision" className="section-padding bg-white">
      <div className="container-max">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
          className="text-center mb-16"
        >
          <motion.h2 variants={itemVariants} className="text-4xl font-bold text-gray-900 mb-4">
            {data.name}
          </motion.h2>
          <motion.p variants={itemVariants} className="text-xl text-gray-600 max-w-3xl mx-auto text-left text-justify">
            {data.descriptionLine1}
            <br />
            <br />
            {data.descriptionLine2}
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default MyVisionSection; 